import { fromJS } from 'immutable';
import { moduleName } from '../constants';

const SET_TENANCY_LOCALE = `${moduleName}/tenancyLocale/SET_TENANCY_LOCALE`;
const LOAD_CUSTOM_LANG_PACK = `${moduleName}/tenancyLocale/CUSTOM_LANG_PACK_LOAD`;

const initialState = fromJS({
  locale: undefined,
  loadedCustomLangPackLocales: [],
});

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_TENANCY_LOCALE:
      return state.set('locale', action.locale);
    case LOAD_CUSTOM_LANG_PACK:
      return state.set(
        'loadedCustomLangPackLocales',
        state.get('loadedCustomLangPackLocales').push(action.locale)
      );
    default:
      return state;
  }
};

const setTenancyLocale = (locale) => ({
  type: SET_TENANCY_LOCALE,
  locale,
});

const loadCustomLangPack = (locale) => ({
  type: LOAD_CUSTOM_LANG_PACK,
  locale,
});

export default reducer;
export {
  SET_TENANCY_LOCALE,
  LOAD_CUSTOM_LANG_PACK,
  setTenancyLocale,
  loadCustomLangPack,
};
